import { getCurrentConnectionInfo } from 'portal-sdk';
import { PortalConnection } from 'vet-bones/utils/portal';

import { usePortalConnectionsWithDemo } from 'src/common/hooks/usePortalConnectionsWithDemo';

export const usePortalConnection = (): PortalConnection | null => {
  try {
    const portalConnections = usePortalConnectionsWithDemo();
    const connectionIndex = getCurrentConnectionInfo(window)?.connectionIndex;
    const portalConnection = portalConnections?.find(
      ({ index }) => index === connectionIndex
    );
    return portalConnection || null;
  } catch (err) {
    console.error(err);
    return null;
  }
};
